export default __webpack_public_path__ + "static/media/iconfinder_react_1296845.acecaab0.svg";